import axios from 'axios';
import { API_IAM } from 'Constants/client-modules';
import { IAM_API_URL } from 'Constants/apis';

import * as ACTION_TYPES from './types';

export function iamDoctorLogin({ email, password, otpMethod }) {
  return {
    types: [
      ACTION_TYPES.IAM_DOCTOR_LOGIN_REQUESTED,
      ACTION_TYPES.IAM_DOCTOR_LOGIN_SUCCESS,
      ACTION_TYPES.IAM_DOCTOR_LOGIN_FAILED,
    ],
    promise: client =>
      client.post(
        '/auth/pw/email',
        {
          email,
          password,
          accountType: 2,
          otpMethod,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      ),
    options: {
      clientName: API_IAM,
    },
  };
}

export function iamChangePassword({ oldPassword, newPassword }) {
  return {
    types: [
      ACTION_TYPES.IAM_CHANGE_PASSWORD_REQUESTED,
      ACTION_TYPES.IAM_CHANGE_PASSWORD_SUCCESS,
      ACTION_TYPES.IAM_CHANGE_PASSWORD_FAILED,
    ],
    promise: client =>
      client.post(
        '/auth/pw/change',
        {
          oldPassword,
          newPassword,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      ),
    options: {
      clientName: API_IAM,
    },
  };
}

export function iamLoginWithLimitedDevices({ token }) {
  return {
    types: [
      ACTION_TYPES.IAM_LIMITED_DEVICE_LOGIN_REQUESTED,
      ACTION_TYPES.IAM_LIMITED_DEVICE_LOGIN_SUCCESS,
      ACTION_TYPES.IAM_LIMITED_DEVICE_LOGIN_FAILED,
    ],
    promise: client =>
      client.post(
        '/auth/magiclink/login-with-limited-devices',
        {
          token,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      ),
    options: {
      clientName: API_IAM,
    },
  };
}

export function iamVerifyPhoneRequest({ challengerId, otp }) {
  return {
    types: [
      ACTION_TYPES.IAM_VERIFY_OTP_REQUESTED,
      ACTION_TYPES.IAM_VERIFY_OTP_SUCCESS,
      ACTION_TYPES.IAM_VERIFY_OTP_FAILED,
    ],
    promise: client =>
      client.post(
        '/auth/otp/verify',
        {
          challengerId,
          otp,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      ),
    options: {
      clientName: API_IAM,
    },
  };
}

export function iamGetUserDetails(doctorId) {
  return {
    types: [
      ACTION_TYPES.IAM_USER_DETAILS_REQUESTED,
      ACTION_TYPES.IAM_USER_DETAILS_SUCCESS,
      ACTION_TYPES.IAM_USER_DETAILS_FAILED,
    ],
    promise: client =>
      client.get(`/doctors/${doctorId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    options: {
      clientName: API_IAM,
    },
  };
}

export function authResendOTPRequest({ challengerId, otpMethod }) {
  return {
    types: [
      ACTION_TYPES.AUTH_OTP_RESEND_REQUEST_REQUESTED,
      ACTION_TYPES.AUTH_OTP_RESEND_REQUEST_SUCCESS,
      ACTION_TYPES.AUTH_OTP_RESEND_REQUEST_FAILED,
    ],
    promise: client =>
      client.post('/auth/otp/resend', {
        challengerId,
        otpMethod,
      }),
    options: {
      clientName: API_IAM,
    },
  };
}

export function authLogout() {
  return {
    type: ACTION_TYPES.AUTH_LOGOUT,
    payload: {},
  };
}

export function logout(refreshToken) {
  localStorage.removeItem('firebase-token');
  axios.post(
    `${IAM_API_URL}/auth/revoke`,
    { refresh_token: refreshToken },
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    },
  );
  return dispatch => {
    dispatch(authLogout());
  };
}

export function registerNotificationToken(notificationToken) {
  return {
    type: ACTION_TYPES.REGISTER_NOTIFICATION_TOKEN,
    payload: notificationToken,
  };
}

export function unRegisterNotificationToken(notificationToken) {
  return {
    type: ACTION_TYPES.UNREGISTER_NOTIFICATION_TOKEN,
    payload: notificationToken,
  };
}
